"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AxiosUserInstance = exports.AxiosRefreshToken = exports.Helper = exports.Constant = void 0;

var _getHandleAuthorization = _interopRequireDefault(require("./get-handle-authorization"));

var _const = require("./const");

var _axiosConfig = require("./axios-config");

var _axiosUserInstance = require("./axios-user-instance");

var _axiosRefreshToken = _interopRequireDefault(require("./axios-refresh-token"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Constant = {
  STORAGE: _const.STORAGE,
  getCookieOption: _const.getCookieOption
};
exports.Constant = Constant;
var Helper = {
  axiosConfig: _axiosConfig.axiosConfig
};
exports.Helper = Helper;
var AxiosRefreshToken = {
  exchangeRefreshToken: _axiosRefreshToken.default
};
exports.AxiosRefreshToken = AxiosRefreshToken;
var AxiosUserInstance = {
  getAxiosUserInstance: _axiosUserInstance.getAxiosUserInstance,
  clearSingletonInstance: _axiosUserInstance.clearSingletonInstance
};
exports.AxiosUserInstance = AxiosUserInstance;
var _default = _getHandleAuthorization.default;
exports.default = _default;